import React from "react"
import { useTranslation } from "react-i18next"

import { MAX_LENGTH_PROJECT_NAME } from "shared/types/Project"
import { TextInput } from "shared/ui/input/text/TextInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomLabelInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomLabelInput = React.memo(
  ({ hideLabel, autoFocus }: RoomLabelInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <TextInput.Root
        name="room.label"
        className="room-form__label"
        label={t("Room.label")}
        maxLength={MAX_LENGTH_PROJECT_NAME}
        autoFocus={autoFocus}
        readonly={isReadonly}
        disabled={isDisabled}
      >
        {!hideLabel ? <TextInput.Label /> : null}
        <TextInput.Focus>
          <TextInput.Input data-testid="room__title__input" />
          <TextInput.Counter />
        </TextInput.Focus>
        <TextInput.Readonly />
        <TextInput.ErrorMessage />
      </TextInput.Root>
    )
  }
)
